import { render, staticRenderFns } from "./ScenarioRephrasePrompt.vue?vue&type=template&id=9348754e&scoped=true&"
import script from "./ScenarioRephrasePrompt.vue?vue&type=script&lang=js&"
export * from "./ScenarioRephrasePrompt.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioRephrasePrompt.vue?vue&type=style&index=0&id=9348754e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9348754e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCheckbox,
  VDialog,
  VIcon,
  VProgressCircular,
  VSelect,
  VTextField,
  VTextarea,
  VTooltip,
})
